import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-sticky-header',
  templateUrl: './sticky-header.component.html',
  standalone: true,
})
export class StickyHeaderComponent {
  @ViewChild('stickyHeaderMain') stickyHeaderMain!: ElementRef;
  @ViewChild('stickyHeaderAddHeaderHeight') stickyHeaderAddHeaderHeight!: ElementRef;
  @ViewChild('stickyHeaderHeader') stickyHeaderHeader!: ElementRef;
  @HostBinding('style.display') display = 'none';
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter();
  _show = false;

  constructor(private readonly renderer: Renderer2) {}

  @Input() set show(_show: boolean) {
    this._show = _show;
    if (this._show) {
      this.display = 'block';
      this.addHeaderMargin();
      return;
    }
    this.display = 'none';
  }

  addHeaderMargin(): void {
    // Could use MutationObserver also, is mandatory to adapt element dynamically
    setTimeout(() => {
      const height = this.stickyHeaderHeader.nativeElement.querySelector('[header]').offsetHeight;
      this.renderer.setStyle(this.stickyHeaderAddHeaderHeight.nativeElement, 'height', `${height}px`);
    }, 0);
  }

  sendClose() {
    this.close.emit('');
  }
}
